import '@/ui/mobile.css';

import type { GatsbyBrowser } from 'gatsby';
import React from 'react';

import { Calculator } from '@/context/calculator';
import { MediaQuery } from '@/context/media-query';
import { BaseLayout } from '@/templates/base-layout';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
    return <BaseLayout {...props}>{element}</BaseLayout>;
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
    return (
        <MediaQuery>
            <Calculator>{element}</Calculator>
        </MediaQuery>
    );
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({ routerProps: { location } }) => {
    if (!location.hash) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
        });
    }

    return false;
};
